// extracted by mini-css-extract-plugin
export default {"item":"_68ed0cb5","isConnectLink":"_a4514fa4","isLegalLink":"_bebb0bf9","isGlobalSitesLink":"_5fdc60c9","contact1stdibsLink":"_64adfb8a","contact1StdibsLink":"_64adfb8a"};